import { Divider, Typography, Container } from '@mui/material'
import { Person } from '@src/api/@types/GetPersonDTO'
import { capitalizeFirstLetter,capitalizeFirstLetterOnly } from '@src/services/Formatter'
import { FC } from 'react'

interface TitleSectionProps {
  title: string
  profileData?: Person
}

const TitleSection: FC<TitleSectionProps> = ({ title, profileData }) => {
  const sectionTitleStyles = {
    mb: 4,
    ml:{ xs: 0, sm: 1, md: 2, lg: 2 },
    mt: 2.5,
    fontWeight: '200',
    fontSize: { xs: '1.5rem', sm: '1.5rem', md: '1.5rem', lg: '2rem' },
  };

  return (
    <>
      <Container maxWidth={false} disableGutters={true} sx={{ mb: 4}}>
        <Container>
          <Typography variant="h4" sx={sectionTitleStyles}>
          {capitalizeFirstLetterOnly (title)}
          </Typography>
          {profileData && (
            <Typography variant="h4" sx={{ fontWeight: 200,ml:{ xs: 0, sm: 1, md: 2, lg: 2 },mb:3 }}>
              {capitalizeFirstLetter(profileData.firstName)} {capitalizeFirstLetter(profileData.lastName)}
            </Typography>
          )}
        </Container>
        <Divider sx={{ bgcolor: 'grey.900' }} />
      </Container>
    </>
  );
};

export default TitleSection;
